import { render, staticRenderFns } from "./ServiceProviderServiceCreation.vue?vue&type=template&id=04226044&"
import script from "./ServiceProviderServiceCreation.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderServiceCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports